export enum SessionType {
    PAYMENT = 'payment',
    TOKENIZATION = 'tokenization'
}

export interface SessionConfig {
    transactionId?: string | null;
    encodedSessionData: string;
    sessionType: SessionType;
}
